import { decryptData, encryptData } from '../environment/data/privateHelpers.js';
import { isEncrypted } from '../typeValidation/basicGuards.js';
import '../typeValidation/booking.js';
import { isNullish } from '../typeValidation/nullish.js';
import '../typeValidation/draftWaypoint.js';
import '../typeValidation/feedback.js';
import '../environment/crypto/index.js';
import 'dayjs';
import '@caresend/types';
import 'immutability-helper';
import 'lodash-unified';
import '../formatters/string.js';
import 'ngeohash';
import '../formatters/location.js';
import '../initializers/user.js';
import '../typeValidation/note.js';
import '../typeValidation/procedure.js';
import '../typeValidation/samples.js';
import '../typeValidation/shift.js';
import '../typeValidation/shipmentInfo.js';
import '../typeValidation/supply.js';
import '../typeValidation/timeSlot.js';
import '../typeValidation/waypoint.js';
import '../typeValidation/waypointAction.js';

const encryptValueHelper = async (value, accessAttributes, shouldEncrypt) => {
  var _a;

  if (isNullish(value)) return;
  if (isEncrypted(value)) return value;
  const shouldEncryptValue = (_a = shouldEncrypt === null || shouldEncrypt === void 0 ? void 0 : shouldEncrypt(value)) !== null && _a !== void 0 ? _a : true;
  if (!shouldEncryptValue) return value;
  return encryptData(value, accessAttributes);
};
/**
 * Maybe encrypts a value if it is not already encrypted and the `shouldEncrypt`
 * function returns true. Otherwise, returns the original value.
 */


const maybeEncryptValue = async (value, accessAttributes, shouldEncrypt) => encryptValueHelper(value, accessAttributes, shouldEncrypt);
/**
 * Encrypts a value if it is not already encrypted. Otherwise, returns the original value.
 */

const encryptValue = async (value, accessAttributes) => encryptValueHelper(value, accessAttributes);
/**
 * Decrypts a value if it is encrypted. Otherwise, returns the original value.
 */

const maybeDecryptValue = async value => {
  if (isNullish(value)) return;
  if (!isEncrypted(value)) return value;
  return decryptData(value);
};

export { encryptValue, maybeDecryptValue, maybeEncryptValue };
